
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class Button extends Vue {
    @Prop({ type: String, default: '' }) name: string;
    @Prop({ type: String, default: 'button' }) type: string;
    @Prop({ type: String, default: '' }) label: string;
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'primary' }) variant: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;
    @Prop({ type: Boolean, default: false }) isLoading: boolean;
    @Prop({ type: String, default: '' }) elementClass: string;
    @Prop({ type: String, default: '' }) inputClass: string;
    @Prop({ type: String, default: '' }) outerClass: string;

    click(event) {
      this.$emit('click', event);
    }

    get disenabled() {
      return this.isLoading || this.disabled;
    }

    get textStyles() {
      return {
        visibility: this.isLoading ? 'hidden' : ''
      }
    }

    elementClasses(context, classes) {
      return classes.concat([
        `${this.elementClass}`,
        `${this.size}`,
        `${this.name}`,
        `modifier-wrapper--${context.type}`
      ])
    }

    inputClasses(context, classes) {
      if (this.disabled) {
        classes.push('vue-button-disabled');
      }
      if (this.inputClass) {
        classes.push(this.inputClass);
      }

      if (this.variant === 'quantity') {
        classes.push('vue-button-red');
        return classes.concat([
          'vue-button-small',
          `${this.elementClass}`
        ])
      } else if (this.variant === 'product-edit') {
        classes.push('vue-button-darkgray');
        return classes.concat([
          'vue-button-small',
          `${this.elementClass}`
        ])
      } else if (this.variant === 'small-primary') {
        classes.push('vue-button-red');
        return classes.concat([
          'vue-button-small',
          `${this.elementClass}`
        ])
      } else if (this.variant === 'small-secondary') {
        classes.push('vue-button-gray');
        return classes.concat([
          'vue-button-small',
          `${this.elementClass}`
        ])
      } else if (this.variant === 'primary') {
        classes.push('vue-button-red');
      } else if (this.variant === 'secondary') {
        classes.push('vue-button-gray');
      } else if (this.variant === 'tertiary') {
        classes.push('vue-button-darkgray');
      } else if (this.variant === 'text') {
        classes.push('vue-button-text');
      }
      return classes.concat([
        'vue-button',
        `${this.elementClass}`
      ])
    }
}
